/**
 * PAX — PwaUpdateToast
 *
 * Nasłuchuje eventu `pax:sw-update-available` (emitowanego przez registerServiceWorker
 * gdy nowy Service Worker jest zainstalowany i czeka na aktywację) i pokazuje toast
 * "Dostępna nowa wersja aplikacji" z przyciskiem "Zaktualizuj".
 *
 * Po kliknięciu:
 *  1. activateWaitingServiceWorker() wysyła SKIP_WAITING do SW
 *  2. SW przejmuje kontrolę → event `controlling` w registerServiceWorker
 *  3. window.location.reload() ładuje świeży bundle
 *
 * Zapobiega scenariuszowi w którym użytkownik pracuje wiele dni na starej wersji.
 */
import { useEffect } from 'react';
import { toast } from 'sonner';
import { activateWaitingServiceWorker } from './registerServiceWorker';

export default function PwaUpdateToast() {
  useEffect(() => {
    const onUpdate = () => {
      toast('Dostępna nowa wersja PAX', {
        description: 'Kliknij Zaktualizuj aby przeładować aplikację.',
        duration: Infinity,
        action: {
          label: 'Zaktualizuj',
          onClick: () => activateWaitingServiceWorker(),
        },
      });
    };
    window.addEventListener('pax:sw-update-available', onUpdate);
    return () => window.removeEventListener('pax:sw-update-available', onUpdate);
  }, []);

  return null;
}
